import {
    Component,
    Input,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ICredentialStoreConfigurationEntry } from '@models';

@Component({
    selector: 'ui-dynamic-configuration-form',
    templateUrl: './dynamic-configuration-form.component.html',
})
export class DynamicConfigurationFormComponent {
    @Input() dynamicFormEntries!: ICredentialStoreConfigurationEntry[];
    @Input() form!: FormGroup;
}
